import type { components } from "@dolfin/api-admin";

export type ProblemDetails = components["schemas"]["ProblemDetails"];

// ProblemDetails extensions are dynamic, so the generated type lacks `code` (written by the backend's Result.cs).
// Branch on `code`, never `title`: title is documented as prose and may diverge.
export type ProblemDetailsWithCode = ProblemDetails & { code?: string };

export interface FormattedProblem {
  title: string;
  detail?: string;
  status?: number;
}

export function formatProblem(
  problem: ProblemDetails | null | undefined,
  fallback = "Something went wrong.",
): FormattedProblem {
  if (!problem) return { title: fallback };

  const status =
    typeof problem.status === "number"
      ? problem.status
      : typeof problem.status === "string"
        ? Number(problem.status) || undefined
        : undefined;

  return {
    title: problem.title?.trim() || fallback,
    detail: problem.detail?.trim() || undefined,
    status,
  };
}
